import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import Swal from 'sweetalert2';
import { CodessearchComponent } from '../codessearch/codessearch.component';
import { SuppliesModel } from 'src/app/models/SuppliesModel';
import { SuppliesService } from 'src/app/services/SuppliesService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialog } from '@angular/material/dialog';
import { DoctorssearchComponent } from '../doctorssearch/doctorssearch.component';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { HospitalsModel } from 'src/app/models/HospitalsModel';
import { HospitalsService } from 'src/app/services/HospitalsService';
import { LkpBanksService } from 'src/app/services/LkpBanksService';
import { LkpBanksModel } from 'src/app/models/LkpBanksModel';
import { LkpExpenssesService } from 'src/app/services/LkpExpenssesService';
import { LkpExpenssesModel } from 'src/app/models/LkpExpenssesModel';
import { TranslateService } from '@ngx-translate/core';       /// Change Language
import { TransactionsService } from 'src/app/services/TransactionsService';
import { TransactionsModel } from 'src/app/models/TransactionsModel';
import { RevenuesearchComponent } from '../revenuesearch/revenuesearch.component';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { LkpRevenueModel } from 'src/app/models/LkpRevenueModel';
import { LkpRevenueService } from 'src/app/services/LkpRevenueService';
import { Router } from '@angular/router';

@Component({
  selector: 'app-revenue',
  templateUrl: './revenue.component.html',
  styleUrls: ['./revenue.component.css']
})
export class RevenueComponent implements OnInit {
  trtype = 'Rev' ;
  trserial = '' ;
  trdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  trkind = '1' ;
  trvalue = 0.00 ;
  trcurrency = '1';
  trrate = 1.00;
  trchno = '' ;
  trchduedate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
  trcln_supp = '' ;
  trbank = '9' ;
  trclass = '' ;
  trdoctor = '' ;
  trhospital = '1' ;
  trdescription = '' ;
  compcode = '1' ;
  userid = '' ;
  modifieddate = '' ;

  supCode = '';
  supName = '';
  supAddress = '';
  supNotes ='';
  supGroup = '';

  userID = 'sa';
  clasCCode='';
  clasCName ='';
  New_trvalue = 0 ;
  trcln_supp_Name ='';
  trclass_Name ='';
  trdoctor_Name ='';
  trhospital_Name ='';
  bank_Name='';
  wk_warrning = '';
  wk_Cheque = true;
  hospitalList: HospitalsModel[] =[];
  bankList: LkpBanksModel[] =[];
  revenueList : LkpRevenueModel[] = [];

  ReportURL0 =  'CocReports/Revenue';
  Par1 = this.trtype;

  constructor(public suppliesService: SuppliesService,
    public supplies: SuppliesModel,
    public suppSelectedData: SuppliesModel,
    public storage: LocalStorageService,
    private dialogref: MatDialog,
    public doctorSelectedData: DoctorsModel,
    public doctorsService: DoctorsService,
    public hospitalService : HospitalsService,
    public lkpbanksService : LkpBanksService,
    public lkpbanks : LkpBanksModel,
    public lkprevenueService :LkpRevenueService,
    public lkprevenue : LkpRevenueModel,
    public transactionsrevice : TransactionsService,
    public transactions :TransactionsModel,
    public translate: TranslateService,
    public transactionsSelecteData : TransactionsModel,
    public patientsSelectedData: DatabankModel,
    public dataBankService: DataBankService,
    public route: Router) { }

  ngOnInit(): void {
    this.lookupgHospital();
    this.LookupBanks();
    this.RetriveBankDefult();
    this. LookupRevenueType();
    this.retriveNextExp();

    this.trvalue =   this.storage.retrieve('stgValue');
    this.trcln_supp =  this.storage.retrieve('stgPatientCode');
    this.trcln_supp_Name =  this.storage.retrieve('stgPatientName');
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
 //// ---------------- Get Next Serial ------------------------
 retriveNextExp() {
  this.transactionsrevice
    .getSerialTransactions(this.trtype,this.storage.retrieve('stgcompCode'))
    .subscribe((data: TransactionsModel) => {
      this.trserial = data.trserial;
    });
}
RetriveBankDefult(){
this.lkpbanksService.getBankDefulte(this.storage.retrieve('stgcompCode')).subscribe((data: LkpBanksModel) => {
  this.trbank = data.bnkcode;
})
}
ShowChequeInfo(){
  if(this.trkind != '2')
  {this.wk_Cheque = true;}
  else
  { this.wk_Cheque = false;}
  this.MesgWarrning();
}
switchArabic(){
  this.translate.use('ar');
  document.documentElement.dir = "rtl";
}
switchEnglish(){
  this.translate.use('en');
  document.documentElement.dir = "ltr";
}
openDialogSerial(){
    const dialogRef = this.dialogref.open(RevenuesearchComponent, {
      data: {
        dataKey: this.transactionsSelecteData,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        this.trserial = result.trserial;
        this.retriveexpenses();

        dialogSubmitSubscription.unsubscribe();

      });

}

retriveexpenses(){
  this.transactionsrevice.getTransactions(this.trtype,this.trserial,this.compcode).subscribe((data: TransactionsModel) => {
    this.trdate = formatDate(data.trdate, 'yyyy-MM-dd', 'en');
    this.trkind = data.trkind;
    this.trvalue = data.trvalue;

    this.supName = data.supname;
    this.trdescription = data.trdescription;
    this.trhospital = data.trhospital;
    this.trbank = data.trbank;
    this.trclass = data.trclass;
    this.trdoctor =data.trdoctor;
    this.trcln_supp = data.trcln_supp;
    this.retrivesupplier();
    this.retrivedoctors();
  })

}
openDialogDoctor(){
  const dialogRef = this.dialogref.open(DoctorssearchComponent,
    {
      data: {
        dataKey: this.doctorSelectedData,
        type : ''
      }
    });
  dialogRef.afterClosed().subscribe(result => { 
  });

  const dialogSubmitSubscription =
    dialogRef.componentInstance.submitClicked.subscribe(result => {
      this.trdoctor = result.docCode;
      this.trdoctor_Name = result.docName;

      this.retrivedoctors();
      dialogSubmitSubscription.unsubscribe();
    });
}
openDialogSupplier(){
  const dialogRef = this.dialogref.open(PopuppatientsearchComponent, {
    data: {
      dataKey: this.patientsSelectedData,
    },
  });
  dialogRef.afterClosed().subscribe((result) => {});
  const dialogSubmitSubscription =
    dialogRef.componentInstance.submitClicked.subscribe((result) => {
      this.trcln_supp = result.patientCode;
      this.trcln_supp_Name = result.patientFName;

      dialogSubmitSubscription.unsubscribe();

    });
}
retrivesupplier(){
  this.dataBankService.getPatient(this.trcln_supp,this.compcode).subscribe((data: DatabankModel) => {
    this.trcln_supp_Name = data.patientFName;




  })
}
retrivedoctors(){
  this.doctorsService.getdoctors(this.trdoctor,this.storage.retrieve('stgcompCode')).subscribe((data: DoctorsModel) => {

    this.trdoctor_Name = data.docName;


  }
  );
}

retriveexpensesName(){

}
LookupRevenueType(){
  this.lkprevenueService
  .getRevenueLookupTop(this.storage.retrieve('stgcompCode'))
  .subscribe((data: LkpRevenueModel[]) => {
    for (let i = 0; i < data.length; i++) {
      this.revenueList[i] = data[i];
    }

  });
}
LookupBanks(){
  this.lkpbanksService
  .getBankLookupTop(this.storage.retrieve('stgcompCode'))
  .subscribe((data: LkpBanksModel[]) => {
    for (let i = 0; i < data.length; i++) {
      this.bankList[i] = data[i];
    }

  });
}
lookupgHospital(){
  this.hospitalService
  .getHospitalsLookupTop(this.storage.retrieve('stgcompCode'))
  .subscribe((data: HospitalsModel[]) => {
    for (let i = 0; i < data.length; i++) {
      this.hospitalList[i] = data[i];
    }

  });
}
retrivebank_Name(){

}
submitPayments(){

      this.transactions.trtype  = 'Rev';
      this.transactions.trserial = this.trserial;
      this.transactions.trdate = formatDate(this.trdate, 'yyyy-MM-dd', 'en');
      this.transactions.trkind = this.trkind ;
      this.transactions.trvalue = this.trvalue ;
      this.transactions.trchno = this.trchno ;
      this.transactions.trchduedate =  formatDate(this.trchduedate, 'yyyy-MM-dd', 'en');
      this.transactions.trcln_supp = this.trcln_supp ;
      this.transactions.trbank = this.trbank ;
      this.transactions.trclass = this.trclass ;
      this.transactions.trdoctor = this.trdoctor ;
      this.transactions.trhospital = this.trhospital ;
      this.transactions.trdescription = this.trdescription ;

      this.transactions.userid = this.storage.retrieve('stguserId');
      this.transactions.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.transactions.compcode = this.storage.retrieve('stgcompcode');
      console.log("Type : ",this.transactions.trtype ,"Serial : ",this.transactions.trserial);
      this.transactionsrevice.AddTransactions(this.transactions).subscribe(data => {

      this.mesgSave();
},
  error => { alert(error); }
);
}
deleteExpensses(){
  this.transactionsrevice.delTransactions(this.trtype,this.trserial, this.storage.retrieve('stgcompCode')).subscribe(
    (data: TransactionsModel) => {
      this.trdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.trkind = data.trkind ;
      this.trvalue = 0.00 ;
      this.trcurrency = '1';
      this.trrate = 1.00;
      this.trchno = data.trchno ;
      this.trchduedate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.trcln_supp = data.trcln_supp ;
      this.trbank = data.trbank ;
      this.trclass = data.trclass ;
      this.trdoctor = data.trdoctor ;
      this.trhospital = data.trhospital ;
      this.trdescription = data.trdescription ;
      this.NewData();
    }
  );
}
mesgDelete(){
  Swal({
    title: 'Are you sure?',
    text: 'You will not be able to recover this record!',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then(() => {
      this.deleteExpensses();
      Swal('Deleted!', 'Your record has been deleted.', 'success');

    },
    function (dismiss) {
      if (dismiss === 'cancel') {
        Swal('Cancelled', 'Your record is safe :)', 'error');
      }
    }
  );
}

MesgWarrning(){
  this.New_trvalue =0;
    if( this.trkind != '4' || this.trvalue == 0)
      {
        return;
       } ;
  this.New_trvalue = this.trvalue * 1.5/100

  this.wk_warrning = '..سوف يتم حصم 1.5 % عمولة بنكية' + this.New_trvalue.toString()
  Swal({
    title: 'معاملة بطاقةإئتمانية',
    text:this.wk_warrning,
    type: 'warning',
    showCancelButton: false,
    confirmButtonText: 'OK',
    //cancelButtonText: 'No, keep it',
  })
  ;

}

mesgSave() {
  Swal({
  title: 'Your work has been saved',

  type: 'success',
  showConfirmButton: false,

  timer: 1500
  });
}
NewData(){
  this.trtype = 'Rev' ;
  this.trdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  this.trkind = '1';
  this.trvalue = 0.00 ;
  this.trcurrency = '1';
  this.trrate = 1.00;
  this.trchno = '' ;
  this.trchduedate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
  this.trcln_supp = '' ;
  this.trcln_supp_Name ='';
  this.trbank = '9' ;
  this.trclass = '' ;
  this.trdoctor = '' ;
  this.trdoctor_Name='';
  this.trhospital = '' ;
  this.trdescription = '' ;
  this. retriveNextExp();
  this.RetriveBankDefult();
}
ReportPayment(){
  this.storage.store('stgPar', this.trserial);
  this.storage.store('stgPar1', this.compcode);
  this.submitPayments();
  this.route.navigate(['report-vewier', this.ReportURL0]);
}
}
